import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import './Profile.css';
import CONFIG from '../config.js';

const Profile = () => {
    const { user, fetchData, setFetchData, handleLogout } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState();
    const [editMode, setEditMode] = useState(false);
    const [newProfilePicture, setNewProfilePicture] = useState(null);
    const [newProfilePicFile, setNewProfilePicFile] = useState(null);

    const [loading, setLoading] = useState(true);
    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    const fetchUserDetails = async () => {
        try {
            const userDataResponse = await axios.get(`${url}user/profile?email=${user.email}`, config);
            setUserDetails(userDataResponse.data);
            setFetchData(prev => ({ ...prev, userInfo: userDataResponse.data }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!fetchData.userInfo) {
            fetchUserDetails();
        } else {
            setUserDetails(fetchData.userInfo);
            setLoading(false);
        }
    }, []);

    const handleProfilePictureChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setNewProfilePicFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewProfilePicture(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const saveProfilePicture = async () => {
        if(newProfilePicFile) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("profile_picture", newProfilePicFile);
            
                const response = await axios.patch(`${url}users/${user.email}/profile`,
                    formData,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                setUserDetails({ ...userDetails, profile_picture_url: newProfilePicture });
                setFetchData(prev => ({ ...prev, userInfo: { ...prev.userInfo, profile_picture_url: newProfilePicture } }));
                setNewProfilePicture(null);
                setNewProfilePicFile(null);
                setEditMode(false);
            } catch (error) {
                console.error('Error updating profile:', error.response || error);
            } finally {
                setLoading(false);
            }
        } else {
            setEditMode(false);
        }
    };

    const cancelEdit = () => {
        setNewProfilePicture(null);
        setNewProfilePicFile(null);
        setEditMode(false);
    }

    return (
        <div className="container">
            <div className="main-content">
                <section className="card">
                    <div className="profile-page">
                        <h1>Profile</h1>
                        {loading &&
                            <div className="spinner-container">
                                <ClipLoader color={"#123abc"} loading={loading} size={50} />
                            </div>
                        }
                        {!loading &&
                            <div className="profile-info">
                                <div className="profile-picture-section">
                                    <div>
                                        <img
                                            src={newProfilePicture || userDetails.profile_picture_url}
                                            alt="Profile"
                                            className="profile-picture"
                                        />
                                    </div>
                                    {!editMode && (
                                        <div onClick={() => setEditMode(!editMode)} className="edit-button">
                                            Edit
                                        </div>
                                    )}
                                    {editMode && (
                                        <div className="upload-section">
                                            <input
                                                type="file"
                                                onChange={handleProfilePictureChange}
                                            />
                                            <button onClick={saveProfilePicture}>Save</button>
                                            <button onClick={cancelEdit}>Cancel</button>
                                        </div>
                                    )}
                                </div>
                                <h2>{userDetails.first_name} {userDetails.last_name}</h2>
                                <p>{userDetails.email}</p>
                            </div>
                        }

                        <button onClick={handleLogout} className="logout-btn">
                            Logout
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Profile;